// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2Cy18","icon":"index_icon_3orpj","avatar":"index_avatar_fcijT","menuIcon":"index_menuIcon_1Wd-9"};